import { render, staticRenderFns } from "./flexi.vue?vue&type=template&id=1591b5f5&scoped=true"
import script from "./flexi.vue?vue&type=script&lang=js"
export * from "./flexi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1591b5f5",
  null
  
)

export default component.exports